<mat-dialog-content>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Address Confirmation</h4>
    <i class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <div class="modal-body">
      <address-book-selection [parseObject]="parseObject" name="addressBook" [user]="parseObject.get('user')"></address-book-selection>
    </div>
  <div class="modal-footer">
    <button class="pull-right" type="button" (click)="onProceed()">Proceed</button>
  </div>
</mat-dialog-content>